// The email rule shared with the API (`etappio-api/src/common/email-address.ts`,
// ClickUp 869fmnqxk). Resend, our mail provider, rejects addresses with e.g.
// `ö` before the @, so such an address is stopped at the field instead of
// failing later when the verification email is sent.

/** Trim + lowercase. Characters are never replaced with other characters. */
export function normalizeEmailAddress(value: string): string {
  return value.trim().toLowerCase();
}

const LOCAL_PART = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/i;
const DOMAIN = /^([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i;

export type EmailAddressProblem = 'unsupportedCharacters' | 'invalid';

/**
 * Why an address cannot be used, or null when it can. Characters outside
 * ASCII (å, ä, ö, é …) get their own problem so the field can say so.
 */
export function emailAddressProblem(value: string): EmailAddressProblem | null {
  const email = normalizeEmailAddress(value);
  // eslint-disable-next-line no-control-regex
  if (/[^\x00-\x7f]/.test(email)) return 'unsupportedCharacters';
  const at = email.lastIndexOf('@');
  if (at < 1 || email.length > 320) return 'invalid';
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  return local.length <= 64 && LOCAL_PART.test(local) && DOMAIN.test(domain) ? null : 'invalid';
}

export function isDeliverableEmailAddress(value: string): boolean {
  return emailAddressProblem(value) === null;
}
